import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notice"]
  static values = { duration: { type: Number, default: 3000 } }

  connect() {
    if (this.hasNoticeTarget) this.scheduleHide(this.noticeTarget)
  }

  show() {
    const notice = document.getElementById(this.element.getAttribute("aria-controls"))
    if (!notice) return

    this.hide()
    this.notice = notice
    this.notice.classList.add("is-active")
    this.scheduleHide(this.notice)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
  }

  scheduleHide(notice) {
    window.clearTimeout(this.timeout)
    this.timeout = window.setTimeout(() => {
      notice.classList.remove("is-active")
      if (this.notice === notice) this.notice = null
    }, this.durationValue)
  }

  hide() {
    window.clearTimeout(this.timeout)
    this.notice?.classList.remove("is-active")
    this.notice = null
  }
}
